import React from 'react';

import AutoComplete from './AutoComplete';
import { createPills } from './Pill';
import MenuItem from 'material-ui/MenuItem';
import SelectField from './SelectField';
import TextField from './TextField';
import TimePicker from './TimePicker';


const generateSelectOptions = (options) => options.map((type) => {
    if (typeof type === 'string' ) {
        type = {id: type, name: type};
    }
    return (<MenuItem key={type.id} value={type.id} primaryText={type.name} />);
});


const styles = {
    chip: {
        margin: 4,
    },
};

const BuildDynamicForm = function(fieldList, data, component) {

    const checkConditions = function(conditions) {

        let pass = true;

        for (let field in conditions) {
            if (field === 'roles') {
                console.error('roles not supported yet');
            } else if (conditions.hasOwnProperty(field) && data.hasOwnProperty(field)) {
                if (Array.isArray(conditions[field]) && !Array.isArray(data[field])) {
                    pass = (conditions[field].indexOf( data[field] ) > -1);
                }
            }
            if (!pass) return false;
        }
        return true;
    };

    const generateAutoComplete = function(field) {
        if (field.props.dataSource === undefined && field.dataSource !== undefined) {
            field.props.dataSource = field.dataSource.filter(function(e) { return e !== undefined; })
                .map(function(e) {
                    const pr = {key: e.id, value: e.id, primaryText: e.name};
                    if (field.onSelect !== undefined) {
                        pr.onTouchTap = () => field.onSelect(e);
                    }
                    return {
                        text: e.name,
                        value: <MenuItem {...pr} />
                    }
                });
        }
        const pills = createPills(field.props.value, field.dataSource, field.deleteItem);
        return (
            <div key={field.name}>
                <AutoComplete name={field.name} key={field.name} {...field.props} />
                <div className="cent-form-chips">
                    {pills}
                </div>
            </div>
        );
    };

    var formElements = [];

    fieldList.forEach(function(field) {
        if (field.conditions === undefined || checkConditions(field.conditions)) {
            let element;
            if (field.props === undefined) field.props = {};
            if (field.label !== undefined) {
                field.props.hintText = field.label;
                field.props.floatingLabelText = field.label;
                if (field.name === undefined) field.name = field.label.toLowerCase();
            }
            if (data.hasOwnProperty(field.name)) {
                field.props.value = data[field.name];
            }
            switch (field.type) {
                case 'select':
                    if (field.props.children === undefined && field.children !== undefined) {
                        field.props.children = generateSelectOptions(field.children); // generate children
                    }
                    element = (
                        <SelectField name={field.name} key={field.name} {...field.props} />
                    );
                    break;
                case 'timepicker':
                    element = (
                        <TimePicker name={field.name} key={field.name} {...field.props} />
                    );
                    break;
                case 'autocomplete':
                    element = generateAutoComplete(field);
                    break;
                default: // text
                    element = (
                         <TextField name={field.name} key={field.name} {...field.props} />
                    );
            }
            if (element) { formElements.push(element); }
        }
    });
    return formElements;
};

export default BuildDynamicForm;
